// extracted by mini-css-extract-plugin
module.exports = {"addressDisplay":"jut__AddressDisplay__addressDisplay"};